// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__YtHHp","head":"ProcedureTableInfo_head__X1w_c"};